
const { reactRender } = require('./reactRender');
const { state } = require('./state');
const { fetch } = require('whatwg-fetch');
const config = require('../config');
const { getAllowCookies } = require('./cookieUtils');

const PAGE_SIZE = 8;

var leaderboard = {};
leaderboard.ranks = [ ];
leaderboard.myRank = -1;
leaderboard.myScore = -1;

leaderboard.showLeaderboard = function (clickBack) {
  var myRank = {};
  // myRank.rank = 2;
  // myRank.name = 'steve';
  // myRank.score = 3;

  var pageData = {};
  pageData.page = 1;
  pageData.first = 1;
  pageData.last = 5;

  clickPage = (pageNum) => {
    Promise.all([
      fetch(`${config.BACKEND_URL}/api/getRankPage`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        start: (pageNum - 1) * PAGE_SIZE,
        end: (pageNum) * PAGE_SIZE,
      }),
    }).then(response => response.json()),
    getAllowCookies() && fetch(`${config.BACKEND_URL}/api/getUserRank`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: state.userId,
      }),
    }).then(response => response.json()),
    fetch(`${config.BACKEND_URL}/api/getLeaderboardSize`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: state.userId,
      }),
    }).then(response => response.json())])
    .then(data => {
      const [pageResult, userRankResult, leaderboardSize] = data;

      userRankResult.name = "You: " + userRankResult.name;

      if (!userRankResult.error) {
        myRank = userRankResult;
      }
      pageData.page = pageNum;
      // Page footer formatting
      const pageMin = Math.max(pageNum - 2, 1);
      const pageMax = Math.min(pageNum + 5, Math.ceil(leaderboardSize.count / PAGE_SIZE));
      pageData.first = pageMin;
      pageData.last = pageMax;
      // render the element
      reactRender.leader(clickBack, clickPage, pageData, myRank, pageResult);
    });
  };
  reactRender.leader(clickBack, null, pageData, myRank, []);
  clickPage(1);
}

module.exports = { leaderboard };
